import {
  type Post,
  type ProfileRestingModelEntry,
} from "@package/ui-gql/index-data-access";
import { get } from "lodash";

export function getRestingModelFromFullScreenFlyout(
  post: Post,
): ProfileRestingModelEntry | undefined {
  if (post.flyoutType !== "61111c78003c346c54a26814") {
    return undefined;
  }

  return {
    __typename: "ProfileRestingModelEntry",
    alphaOn:
      get(post, "customData.flyout.fullScreenMedia.transparency") ?? false,
    canInterrupt: true,
    imageSettings: {
      __typename: "ProfileRestingModelEntryImageSettings",
      showTime: get(post, "customData.flyout.fullScreenMedia.duration") ?? 0,
    },
    media: get(post, "customData.flyout.fullScreenMedia.media"),
    playAudio: get(post, "customData.flyout.fullScreenMedia.audio") ?? false,
  };
}

export function getProfileFromProfileSelectFlyout(
  post: Post,
): string | undefined {
  if (post.flyoutType !== "60365c78003c344a72a26814") {
    return undefined;
  }

  return get(post, "customData.flyout.profileSelect.profile");
}
